export default __webpack_public_path__ + "3bd87c7484092d6d17f1dccf31a7d3ea.webp";